import { render } from "./CertLayer.vue?vue&type=template&id=94498166&scoped=true&ts=true"
import script from "./CertLayer.vue?vue&type=script&lang=ts"
export * from "./CertLayer.vue?vue&type=script&lang=ts"

import "./CertLayer.vue?vue&type=style&index=0&id=94498166&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94498166"]])

export default __exports__